import React from 'react';
import { Link } from 'react-router-dom';
import { PhotoIcon, PlusIcon, TrashIcon } from '@heroicons/react/24/outline';
import {
  
  EyeIcon
} from '@heroicons/react/24/outline';

const MediaRelatedTab = ({ 
  register, 
  errors, 
  watch, 
  setValue, 
  inputClassName,
  imagePreviews,
  handleImageChange,
  removeImage,
  addRelatedProduct,
  removeRelatedProduct,
  relatedProducts
}) => {
  
  return (
    <div className="bg-white rounded-lg shadow-sm border border-gray-200 overflow-hidden mt-3">
      <div className="px-6 py-4  from-blue-50 to-indigo-50 border-b border-gray-200">
        <h2 className="text-xl font-semibold text-gray-900 flex items-center">
          <PhotoIcon className="h-6 w-6 mr-2 text-[#009efb]" />
          Media & Related Products
        </h2>
      </div>
      <div className="p-6 space-y-6">
        <div>
          <label className="block text-sm font-medium text-gray-700">Media URL</label>
          <input
            type="text"
            {...register('media_url')}
            className={`${inputClassName} ${
              errors.media_url ? 'border-red-500 focus:border-red-500 focus:ring-red-500' : ''
            }`}
            placeholder="Enter media URL"
          />
          {errors.media_url && (
            <p className="mt-1 text-sm text-red-600">{errors.media_url.message}</p>
          )}
        </div>
        
        <div className="space-y-4">
          <label className="block text-sm font-semibold text-gray-700">
            Product Images
          </label>
          <div className="border-2 border-dashed border-gray-300 rounded-lg p-6 text-center hover:border-gray-400 transition-colors">
            <PhotoIcon className="mx-auto h-12 w-12 text-gray-400" />
            <div className="mt-4">
              <input
                type="file"
                accept="image/*"
                onChange={handleImageChange}
                multiple
                className="hidden"
                id="image-upload"
              />
              <label
                htmlFor="image-upload"
                className="cursor-pointer inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md text-white bg-[#009efb] hover:bg-[#0089db] focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-[#009efb]"
              >
                <PlusIcon className="h-4 w-4 mr-2" />
                Upload Images
              </label>
            </div>
            <p className="mt-2 text-xs text-gray-500">PNG, JPG, GIF up to 10MB each</p>
          </div>
           
          {imagePreviews.length > 0 && (
          <div className="grid grid-cols-1 md:grid-cols-6 gap-4 max-h-[400px] overflow-y-auto md:max-h-none">

            {imagePreviews.map((image, index) =>
              image.status !== 404 && (
                <div
                  key={index}
                  className="relative group overflow-hidden rounded-lg"
                >
                  <img
                    src={image?.path ? image.path : image?.url}
                    alt={`Product preview ${index + 1}`}
                    className="w-full h-32 object-cover rounded-lg"
                  />

                  {/* Black transparent overlay on hover */}
                  <div className="absolute inset-0 bg-black/0  group-hover:bg-black/40 transition duration-300 rounded-lg"></div>

                  {/* View button centered */}
                  <Link
                    to={image?.path ? image.path : image?.url}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="absolute inset-0 flex items-center justify-center text-white font-semibold opacity-0 group-hover:opacity-100 transition-opacity z-10"
                  >
                    <span className="bg-gray-200 text-black px-3 py-1 rounded hover:bg-gray-200 transition">
                    <EyeIcon className="h-6 w-6 bg-gray-200 text-black p-1 rounded hover:bg-gray-200 transition" />
                    </span>
                  </Link>

                  {/* Trash icon in top-right */}
                  <button
                    type="button"
                    onClick={() => removeImage(index)}
                    className="absolute top-2 right-2 bg-red-500 text-white rounded-full p-1 hover:bg-red-600 opacity-0 group-hover:opacity-100 transition-opacity z-20"
                  >
                    <TrashIcon className="h-4 w-4" />
                  </button>
                </div>
              )
            )}
          </div>
        )}
 
        </div>

        <div className="space-y-4">
          <div className="flex items-center justify-between">
            <label className="block text-sm font-semibold text-gray-700">
              Related Products
            </label>
            <button
              type="button"
              onClick={addRelatedProduct}
              className="inline-flex items-center px-3 py-1 border border-transparent text-sm font-medium rounded-md text-[#009efb] bg-blue-50 hover:bg-blue-100 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-[#009efb]"
            >
              <PlusIcon className="h-4 w-4 mr-1" />
              Add Product
            </button>
          </div>
          
          <div className="space-y-3">
           
            {Array.isArray(watch('related_products')) && watch('related_products')?.map((_, index) => (
              <div key={index} className="flex items-center gap-3 p-3 bg-gray-50 rounded-lg">
                <div className="flex-1">
                  <select
                    
                    {...register(`related_products.${index}.id`)}
                    className={`${inputClassName} ${
                      errors.related_products?.[index]?.id ? 'border-red-500' : ''
                    }`}
                    value={watch(`related_products.${index}.id`) || ''}
                    placeholder="Enter product name"
                   >
                    <option value="">Select Product</option>
                    {relatedProducts?.data?.map((product) => (
                      <option key={product.id} value={product.id}>
                        {product.name}
                      </option>
                    ))}
                    </select>
                  {errors.related_products?.[index]?.name && (
                    <div className="text-red-500 text-sm mt-1">
                      {errors.related_products[index].name.message}
                    </div>
                  )}
                </div>
                <button
                  type="button"
                  onClick={() => removeRelatedProduct(index)}
                  className="text-red-600 hover:text-red-800 p-2 hover:bg-red-50 rounded-md transition-colors"
                >
                  <TrashIcon className="h-5 w-5" />
                </button>
              </div>
            ))}
             
          </div>
        </div>
      </div>
    </div>
  );
};

export default MediaRelatedTab; 